import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { DividerSizeModel } from './tools/Divider.model';
import { StylesIndexInjections } from 'common-react';

const getMargin = (noMargin: boolean, size: DividerSizeModel | null, equalMargin:
  boolean | null, isMobile = false): number => {
    if (noMargin) return 0;
    if (isMobile) {
     return equalMargin ? 24 : 16;
    }
    return size === 'small' ? 16 : 24;
 };

 export default makeUiStyles<Theme, {
  size: DividerSizeModel,
  equalMargin: boolean,
  fullWidth: boolean,
  noMarginTop: boolean,
  noMarginBottom: boolean
 }>((theme: Theme) => createStyles({
  root: {
    marginTop: ({ size, noMarginTop }) => getMargin(noMarginTop, size, null, false),
    marginBottom: ({ size, noMarginBottom }) => getMargin(noMarginBottom, size, null, false),
    marginLeft: 0,
    marginRight: 0,
    border: 'none',
    borderTop: `1px solid ${theme.color.greys[15]}`,
    width: ({ fullWidth }) => fullWidth ? '100%' : 'auto',
    [theme.breakpoints.down('xs')]: {
      marginTop: ({ equalMargin, noMarginTop }) => getMargin(noMarginTop, null, equalMargin, true),
      marginBottom: ({ equalMargin, noMarginBottom }) => getMargin(noMarginBottom, null, equalMargin, true),
    },
  },
}), { name: 'Divider', index: StylesIndexInjections.UI_ATOMS });
